<template>
    <div class="ball" :style="{ width: ballSize + 'px', height: ballSize + 'px', fontSize: fontSize + 'rem'}">
        <svg height="100%" width="100%">
            <circle cx="50%" cy="50%" r="40%" stroke="#0a509d" :stroke-width="strokeWidth" fill="#ffffff" />
            <text x="50%" y="65%" text-anchor="middle" fill="#0a509d">{{ bubbleId }}</text>
        </svg>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {
        components: {
        },

        props: {
            strokeWidth: {
                type: Number,
                default: 0
            },
            ballSize: {
                type: Number,
                default: 0
            },
            fontSize: {
                type: Number,
                default: 0
            },
            bubbleId: {
                type: Number,
                default: 0
            }
        }
    };
</script>
